export { P80FavoritePage as default } from './P80FavoritePage';
